import React, { useState, useEffect } from "react";

import { useFormikContext } from "formik";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import pt from "date-fns/locale/pt-BR";

import { Box, Grid, GridItem, Icon, Flex } from "@chakra-ui/react";

import { CustomDatepickerWField } from "../../../../components/CustomDatepickerWField";
import { CustomSelectWField } from "../../../../components/CustomSelectWField";

import CriancaService from "../../../../../main/services/CriancaService";
import Group from "../../../ServicosAcolhimento/Visualizar/Group";
import { hasFormChanged } from "../../../../utils/hasFormChanged";
import { useAppContext } from "../../../../../Context/MessageContextProvider";
import { CustomTextArea } from "../../../../components/CustomTextArea";
import { BsFillArrowRightCircleFill } from "react-icons/bs";
import { useHistory, useParams } from "react-router";
import CustomDropzone from "../../../../components/CustomDropzone";
import { handleVerify } from "../../../../utils/handleVerify";
import { format } from "date-fns";
import { createCustomFile } from "../../../../utils/createCustomFile";
import { handleVerifyRedirect } from "../../../../utils/handleVerifyRedirect";
import { handleVerifyRedirectPermission } from "../../../../utils/handleVerifyPermission";
import SemRegistros from "../../../../components/SemRegistros";
import { servicoAcolhimentoFunc } from "../../../../../helpers/Funcionalidades";

export const AnexosCadastrar = ({
  initialValues,
  valuesProps,
  setInitialValues,
  idade16,
  roleKeycloack,
  user,
}) => {
  const { setFieldValue } = useFormikContext();
  const url = window.location.href;
  const { setAnexarCrianca, setEditarAnexoCrianca, setRadioClick, idPJ } =
    useAppContext();
  const [isTextareaFocused, setIsTextareaFocused] = useState(false);
  const [tipoAnexos, setTipoAnexos] = useState({
    options: [],
    isLoading: false,
  });
  const { idAnexo, id } = useParams();
  const history = useHistory();

  const handleGetTipoAnexo = () => {
    setTipoAnexos({
      ...tipoAnexos,
      isLoading: true,
    });

    CriancaService.getListaTipoAnexos()
      .then((res) => {
        let tempOptions = res.data.map((item) => {
          return {
            id: item.id,
            descricao: item.nmCategoria,
            grupo: item.grupo,
          };
        });

        tempOptions = tempOptions.filter((item) => item.id !== 6);

        if (!idade16) {
          tempOptions = tempOptions.filter(
            (item) => ![5, 12, 20, 27].includes(item.id)
          );
        }

        tempOptions = handleVerifyRedirectPermission(
          tempOptions,
          roleKeycloack,
          user,
          idPJ
        );
        tempOptions.sort((a, b) => a.descricao.localeCompare(b.descricao));
        setTipoAnexos({
          options: tempOptions,
          isLoading: false,
        });
      })
      .catch((err) => {
        console.log("Erro ao buscar tipos de anexo:", err);
        setTipoAnexos({
          options: [],
          isLoading: false,
        });
      });
  };

  useEffect(() => {
    setDefaultLocale("pt-br");
    registerLocale("pt-br", pt);
  }, []);

  useEffect(() => {
    if (url.includes("editar") && idAnexo) {
      CriancaService.getAnexoCrianca(idAnexo)
        .then((res) => {
          const date = new Date(res.data.dataDocumento);

          const formattedDate = res.data.dataDocumento
            ? format(date, "dd/MM/yyyy")
            : "";

          const fakeFile = createCustomFile(
            [res.data?.arquivoBase64 ? res.data?.arquivoBase64 : ""],
            res.data?.arquivoNome ? res.data?.arquivoNome : "",
            {
              type: res.data?.arquivoTipo ? res.data?.arquivoTipo : "",
              idAnexo: res.data?.id ? res.data?.id : 0,
            }
          );

          setInitialValues({
            idAnexo: idAnexo,
            dataDocumento: formattedDate,
            tipoAnexo: {
              id: res.data.idTipo ? res.data.idTipo : "",
              descricao: res.data.tipo ? res.data.tipo : "",
              grupo: {
                id: res.data.idCategoria ? res.data.idCategoria : "",
                nome: res.data.categoria ? res.data.categoria : "",
              },
            },
            observacao: res.data.observacao ? res.data.observacao : "",
            anexo: fakeFile,
          });
        })
        .catch((err) => {
          console.log("Erro ao buscar anexo:", err);
        });
    }
  }, [idAnexo, setInitialValues, url]);

  useEffect(() => {
    if (url.includes("cadastrar")) {
      setInitialValues({
        idAnexo: "",
        dataDocumento: "",
        tipoAnexo: "",
        observacao: "",
        anexo: null,
      });
    }
  }, [setInitialValues, url, setFieldValue]);

  return !roleKeycloack.includes(
    servicoAcolhimentoFunc.visualizarParteConsulente
  ) ? (
    <Group title={`${url.includes("cadastrar") ? "Anexar" : "Editar"}`}>
      {url.includes("cadastrar")
        ? setAnexarCrianca(hasFormChanged(initialValues, valuesProps))
        : url.includes("editar")
        ? setEditarAnexoCrianca(hasFormChanged(initialValues, valuesProps))
        : ""}

      <Grid mt="15px" templateColumns="repeat(5, 1fr)" gap={"20px"}>
        <GridItem colSpan={{ base: 4, md: 3 }}>
          <CustomSelectWField
            fieldName="tipoAnexo"
            label="Tipo de Anexo*"
            placeholder="Selecione o Tipo de Anexo"
            getOptionLabel={(option) => option?.descricao}
            getOptionValue={(option) => option?.id}
            isLoading={tipoAnexos.isLoading}
            options={tipoAnexos.options}
            isDisabled={url.includes("editar")}
            onChange={(value) => {
              setFieldValue("tipoAnexo", value ? value : "");
            }}
            onFocus={handleGetTipoAnexo}
          />
        </GridItem>

        {handleVerify(valuesProps) ? (
          <GridItem position="relative" left={0} colSpan={{ base: 4, md: 2 }}>
            <CustomDatepickerWField
              fieldName="dataDocumento"
              label="Data do Documento*"
              placeholder="DD/MM/AAAA"
              maxDate={new Date()}
            />
          </GridItem>
        ) : (
          <Flex alignItems="end" mb={2}>
            <Icon
              aria-label="Voltar"
              color="#169499"
              as={BsFillArrowRightCircleFill}
              boxSize="30px"
              _hover={{ cursor: "pointer" }}
              onClick={() =>
                handleVerifyRedirect(
                  valuesProps,
                  history,
                  id,
                  true,
                  setRadioClick,
                  setAnexarCrianca
                )
              }
            />
          </Flex>
        )}
      </Grid>

      {handleVerify(valuesProps) && (
        <>
          <Box mt={4}>
            <CustomTextArea
              fieldName={"observacao"}
              label={`Observações${
                valuesProps.tipoAnexo.id === 25 ||
                valuesProps.tipoAnexo.id === 29
                  ? "*"
                  : ""
              }`}
              placeholder={"Informe as Observações"}
              setIsTextareaFocused={setIsTextareaFocused}
              maxLength={255}
              isTextareaFocused={isTextareaFocused}
              colorLabel="#5F6377"
            />
          </Box>
          <Box mt={4}>
            <CustomDropzone
              formProps={{ setFieldValue }}
              title={`Anexar*`}
              fieldName="anexo"
              height="42px"
            />
          </Box>
        </>
      )}
    </Group>
  ) : (
    <Box mt={4}>
      <SemRegistros buttonVisible={true} half />
    </Box>
  );
};
